<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import ListDataEditor from '../content/ListDataEditor';
import PlanList from './PlanList'

export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: "",
      redirect: "/devices/plan/list"
    },
    {      
      path: "list",
      components: {
        default: PlanList,
      },
      meta: {search: false},
      name: "Devices plan list",
    },
    {
      path: "list/:id/data/new",
      components: {
        default: PlanList,
        bottomEditor: ListDataEditor
      },
      meta: {search: false},
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Device plan edit"
    },
    {
      path: "list/:id/data/edit/:data_id",
      components: {
        default: PlanList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Device plan data edit"
    },
   
  ]
}
</script>